import type { Clock } from '@sl/core';
import type { Identity } from './identity';

// Explicit walkthrough only. No auth cookie, network, storage, real verification or workspace access.
// A refresh intentionally resets it; the preview never becomes a product identity.
let preview: Identity | null = null;
export const PREVIEW_CODE = '12345678';

export function createPreviewIdentity(name: string, email: string, clock: Clock): Identity {
  const now = clock.now();
  preview = {
    displayName: name.trim() || 'Alex',
    email: email.trim(),
    trialStartedAt: new Date(now).toISOString(),
    trialEndsAt: new Date(now + 90 * 86400000).toISOString(),
    trialActive: true,
  };
  return preview;
}
export function readPreviewIdentity() {
  return preview;
}
export function clearPreviewIdentity() {
  preview = null;
}
